import {
  FieldsBoundaries,
  IFieldsCultureVariations,
  IFieldsResponse,
  IMappedField,
  IPolygon,
} from './types';
import 'leaflet-draw';
import * as L from 'leaflet';
import { getAreaWithUnits } from 'utils/helpers';
import { FIELDS_LAYER_ID } from './map-constants';

export const getPaneZIndex = (index: number) => {
  return 600 - index * 10;
};

type CoordinatesType =
  | [number, number][][][][]
  | [number, number][][][]
  | [number, number][][]
  | [number, number][];

export const reorder = (coordinates: FieldsBoundaries) => {
  const changeArray: any = (coord: CoordinatesType) => {
    if (Array.isArray(coord)) {
      if (!isNaN(coord[0] as any) && !isNaN(coord[1] as any)) {
        return [coord[1], coord[0]];
      } else {
        return (coord as any).map((x: any) => changeArray(x));
      }
    }
    return coord;
  };
  const result = changeArray(coordinates);

  return result;
};

export const mapFieldsResponseData = (
  data: IFieldsResponse,
  fieldsCultureVariations: IFieldsCultureVariations,
): IPolygon[] => {
  const polygons: IPolygon[] = data.features.map(feature => {
    const coordinatesReordered = reorder(feature.geometry.coordinates);
    const markerCenter = L.polygon(coordinatesReordered)
      .getBounds()
      .getCenter();
    const fieldId = feature.properties?.id;
    const fieldVariations = fieldsCultureVariations[fieldId];

    return {
      id: feature.id,
      coordinates: coordinatesReordered,
      weight: 1,
      layerId: FIELDS_LAYER_ID,
      fieldParameters: {
        fieldId,
        fieldId2: feature.properties?.field_id,
        name: feature.properties?.field_name,
        cultureName: feature.properties?.culture_name,
        cultureColor: feature.properties?.culture_color,
        companyId: feature.properties?.company_id,
        companyName: feature.properties?.company_name,
        area: getAreaWithUnits(feature.properties?.area * 10000),
        areaNum: feature.properties?.area * 10000,
        cultureId: feature.properties?.culture_id,
        seasonId: feature.properties?.season_id,
        cultureVariationsArr: fieldVariations || [],
      },
      markerPosition: [markerCenter.lat, markerCenter.lng],
    };
  });

  return polygons;
};

export const filterFieldsByUsedSeedVariations = (
  fields: IMappedField[],
  selectedVariationsIds: number[],
) => {
  const filteredByCultureVariation = fields.filter(field => {
    const fieldVariationsArr = field.fieldParameters.cultureVariationsArr;
    if (fieldVariationsArr.length) {
      let isVariationSelected = false;
      fieldVariationsArr.forEach(variation => {
        const isVariationCompatibleWithFieldCulture =
          variation.culture.id === field.fieldParameters.cultureId;
        if (!isVariationCompatibleWithFieldCulture) {
          isVariationSelected = true;
          return;
        }

        if (selectedVariationsIds.includes(variation.id)) {
          isVariationSelected = true;
        }
      });
      return isVariationSelected;
    }
    return true;
  });
  return filteredByCultureVariation;
};

export const getCultureFieldIds = (
  cultureId: number | null,
  polygons: IPolygon[],
) =>
  polygons
    .filter(polygon => polygon.fieldParameters.cultureId === cultureId)
    .map(polygon => polygon.fieldParameters.fieldId);

export const getVariationFieldIds = (
  variationId: number,
  polygons: IPolygon[],
) =>
  polygons
    .filter(polygon =>
      polygon.fieldParameters.cultureVariationsArr.some(
        variation => variation.id === variationId,
      ),
    )
    .map(polygon => polygon.fieldParameters.fieldId);
